define.alias("ember-truth-helpers/helpers/eq", "settings/helpers/eq");